/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBellOn} from '@fortawesome/pro-duotone-svg-icons';

const AlertsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faBellOn} {...props} />
);

export default AlertsIcon;
